var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "9px",
    viewBox: "0 0 5 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "16x16/ArrowLong_Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KnowledgeBase-99---Interactions",
    transform: "translate(-876.000000, -550.000000)",
    fill: "#E1E2E4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-2.000000, 452.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(716.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16x16/ArrowSmall_Right",
    transform: "translate(132.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64752309,7.37 L10.5237615,10.2462385 C10.7854128,10.5078897 10.7854128,10.9321103 10.5237615,11.1937615 C10.2621103,11.4554128 9.83788973,11.4554128 9.57623846,11.1937615 L6.22623846,7.84376154 C5.96458718,7.58211027 5.96458718,7.15788973 6.22623846,6.89623846 L9.57623846,3.54623846 C9.83788973,3.28458718 10.2621103,3.28458718 10.5237615,3.54623846 C10.7854128,3.80788973 10.7854128,4.23211027 10.5237615,4.49376154 L7.64752309,7.37 Z",
    id: "icon",
    transform: "translate(8.375000, 7.370000) scale(-1, 1) translate(-8.375000, -7.370000) "
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongRight);
export default __webpack_public_path__ + "static/media/ArrowLong_Right.3e42998120ff59cfcd1abe61fad44997.svg";
export { ForwardRef as ReactComponent };